<template lang="pug">
.Header
  .Header-menu
    #AppHeader_logo.Header-logo(
      v-if='logo',
      @mouseover.stop='helperText = "Главное меню"',
      @mouseout.stop='helperText = null'
    )
      img(
        v-if='logo === "default"',
        src='../assets/b3-logo.svg',
        alt='B3'
      )
      img(
        v-else,
        :src='logo',
        alt='логотип'
      )
      i.Icon.IconChevronDown
    nav.Header-nav.Nav
      ul
        li.Nav-item(v-for='item in routers')
          router-link(
            :to='{ name: item.name }',
            :id='"AppHeader_menu_" + item.name'
          )
            span.Nav-icon
              i.Icon(:class='item.iconClass')
            span.Nav-text {{ item.text }}
  .Header-slot
    slot
  .Header-settings.Settings
    .Settings-item.Version(
      v-if='version',
      @mouseover.stop='helperText = "Номер активной версии рабочего пространства"',
      @mouseout.stop='helperText = null'
    )
      span.Version-prefix.Version-prefix--small(title='Версия') В.
      span.Version-prefix Версия
      | № {{ version }}
    .Settings-item(v-if='workspace')
      .Header-select(
        @click='openSelectWorkspacePopup',
        @mouseover.stop='helperText = "Выбрать рабочее пространство"',
        @mouseout.stop='helperText = null'
      )
        i.Icon.IconWorkspace
        span.Settings-workspace(:id='"AppHeader_selectedWS_" + workspace')
          | {{ workspaceInfo && workspaceInfo.status === "broken" ? "[Устаревшее]" : "" }}
          span.Workspace-prefix.Workspace-prefix--small(title='Рабочее пространство') РП
          span.Workspace-prefix Рабочее пространство
          | {{ workspaceInfo ? workspaceInfo.fullName : "№" + workspace }}
        i.Icon.IconChevronDown

    //- Панель пользователя
    user-panel.Settings-item
</template>

<script>
import workspace from '@/mixins/workspace'
import common from '@/mixins/common'
import helpertext from '@/mixins/helpertext'
import UserPanel from '@/components/UserPanel'
import { env } from '@/../config'

export default {
  name: 'app-header',

  mixins: [common, workspace, helpertext],

  components: {
    UserPanel
  },

  computed: {
    workspaceInfo() {
      return this.$store.getters.activeWorkspaceList.filter((v) => v.id === this.workspace)[0]
    },

    logo() {
      return this.$store.getters.logo
    },

    routers() {
      let routers = [
        {
          iconClass: 'IconMenuObjects',
          name: 'objects',
          text: 'Объекты'
        }
        /*{
            iconClass: 'IconMenuAnalytics',
            name: 'analytics',
            text: 'Аналитика'
          },*/

        /*{
            iconClass: 'IconMenuIntegration',
            name: 'integration',
            text: 'Интеграция'
          },
          {
            iconClass: 'IconMenuSettings',
            name: 'settings',
            text: 'Настройки'
          },*/
        //Экран скрыт по задаче https://app.clickup.com/t/2n42p3k
        //"Технологии" сейчас не нужны ни в одном их бизнес-процессов
        /*
        
          iconClass: 'IconMenuTechnologies',
          name: 'technologies',
          text: 'Технологии'
        },
        */
      ]

      if (!this.isPublicWs && this.canEditWs) {
        routers.push({
          iconClass: 'IconMenuReport',
          name: 'reports',
          text: 'Отчеты'
        })
        routers.push({
          iconClass: 'IconMenuModeling',
          name: 'modeling',
          text: 'Моделирование'
        })
      }

      if (this.$store.getters.permissions.canReadTerschema || (this.isPublicWs && this.$store.getters.terschemaListCount > 0)) {
        routers.push({
          iconClass: 'IconMenuTerritories',
          name: 'terschema',
          text: 'Территориальная схема'
        })
      }

      if (this.$store.getters.permissions.canReadControl || (this.isPublicWs && this.$store.getters.controlListCount > 0)) {
        routers.push({
          iconClass: 'IconMenuControl',
          name: 'control',
          text: 'Контроль'
        })
      }

      if (!this.isPublicWs && this.canEditWs && this.$store.getters.permissions.canReadAggregateInfoLayer) {
        routers.push({
          iconClass: 'IconMenuLayers',
          name: 'excel-layer-list',
          text: 'Информационные слои'
        })
      }

      if (env.VUE_APP_SHOW_B3_GIS) {
        routers.push({
          iconClass: 'IconMapLegend',
          name: 'b3-gis',
          text: 'Б3 ГИС'
        })
      }

      return routers
    }
  }
}
</script>

<style lang="scss">
@import '~base';

#app .Header {
  --headerBorderBottom: #{$grey3};
  --headerIconColor: #{$grey1};
  --headerText: #{$black5};
  --headerNavItemHoverBg: #{$grey-light};
  --headerNavItemActiveBg: #{$grey-light};
  --userIconColor: #{$black5};
}

#app[data-theme='dark'] .Header {
  --headerBorderBottom: #{$grey2};
  --headerIconColor: #{$grey1};
  --headerText: #{$white3};
  --headerNavItemHoverBg: #{$black2};
  --headerNavItemActiveBg: #{$black3};
  --userIconColor: #{$grey1};
}
</style>

<style scoped lang="scss">
@import '~base';
.Workspace,
.Version {
  &-prefix {
    display: inline-block;
    margin-right: 5px;

    &--small {
      display: none;
    }
  }
}

.Header {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  border-bottom: 2px solid var(--headerBorderBottom);
  background: var(--appBg);
  line-height: 47px;
  z-index: 10000;

  &-menu {
    flex: 0 0 auto;
    nav {
      display: none;
    }

    &:hover {
      nav {
        display: block;
        width: 72px;
      }
    }
  }

  &-slot {
    color: var(--basicText);
    flex: 1 1 auto;
    padding: 0 0 0 15px;

    b {
      font-size: 12px;
      font-weight: 500;
    }

    .Menu-title {
      display: inline-block;
      margin-top: 2px;
      color: var(--basicText);
    }
  }

  &-settings {
    flex: 0 0 auto;
  }

  &-logo {
    width: 72px;
    height: 48px;
    padding: 0 8px 0 17px;
    line-height: 46px;
    text-align: center;
    cursor: pointer;
    border-right: 2px solid var(--delimiter);

    .Icon {
      margin-left: 4px;
      color: var(--headerIconColor);
      font-size: 18px;
    }

    img {
      max-width: 23px;
      max-height: 30px;
      vertical-align: middle;
    }
  }
  a {
    color: var(--headerText);
    text-decoration: none;
  }
}

.Nav {
  display: block;
  z-index: 5000;

  ul {
    margin: 0;
    padding: 0;
  }

  &-item {
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style-type: none;
    overflow: visible;

    a {
      display: flex;
      align-items: center;
      height: 48px;
      border-top: 1px solid var(--delimiter);
      border-bottom: 1px solid var(--delimiter);
      border-right: 1px solid var(--delimiter);
      margin-bottom: -1px;
      background: var(--appBg);
      line-height: 48px;

      &.router-link-active {
        background: var(--headerNavItemActiveBg);

        .Nav-text {
          color: var(--basicText);
        }
      }

      &:hover {
        background: var(--headerNavItemHoverBg);
        width: 250px;

        .Nav-text {
          display: inline-block;
          color: var(--basicText);
        }
      }
    }
  }

  &-icon {
    width: 72px;
    flex: 0 0 72px;
    text-align: center;
  }

  &-text {
    flex: 1 1 auto;
    display: none;
    font-size: 14px;
    line-height: 1.3;
  }
}

.Settings {
  &-workspace {
    max-width: 300px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
  }

  &-item {
    display: inline-block;
    position: relative;
    font-size: 14px;
    padding: 0 15px;
    color: var(--headerText);
    cursor: pointer;

    &:first-child {
      padding-left: 0;
    }

    span {
      margin-left: 7px;
    }

    .Icon {
      font-size: 18px;
      color: var(--secondaryText);
      margin-left: 7px;

      &:first-child {
        margin-left: 0;
      }
    }

    &:not(:last-child) {
      &:after {
        content: '';
        display: inline-block;
        position: absolute;
        left: 100%;
        width: 1px;
        background: var(--delimiter);
        top: 7px;
        bottom: 6px;
      }
    }
  }
}

@media screen and (max-width: 1340px) {
  .Workspace,
  .Version {
    &-prefix {
      display: none;

      &--small {
        display: inline-block;
      }
    }
  }

  .Settings {
    &-workspace {
      max-width: 250px;
    }
  }
}

@media screen and (max-width: 1280px) {
  .Settings {
    &-workspace {
      max-width: 150px;
    }
  }
}

@media screen and (max-width: 1200px) {
  .Settings {
    &-workspace {
      max-width: 100px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .Settings {
    &-workspace {
      max-width: 80px;
    }
  }
}

@media screen and (max-width: 1023px) {
  .Version {
    display: none;
  }
}
@media screen and (max-width: 940px) {
  .Settings {
    &-workspace {
      display: none;
    }
  }
}

@media only screen and (-webkit-min-device-pixel-ratio: 2) {
  .Settings {
    &-workspace {
      max-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue